import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { initializeDb } from './lib/db';
import { sampleRecipes } from './scripts/seedRecipes';
import './index.css';

const init = async () => {
  await initializeDb(sampleRecipes);

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
};

init().catch(console.error);
